module.exports = __webpack_public_path__ + "static/media/SeeSignage-logo-horizontal-on-black-500px.c7bc961d.png";